// extracted by mini-css-extract-plugin
export var banner = "_tm-0";
export var settingRow = "_tm-2";
export var titleIcon = "_tm-1";